<template lang="pug">
.badge
  slot(name="prepend")
  span {{ label }}
</template>

<script>
export default {
  name: 'Badge',
  props: {
    label: {
      type: String,
      required: true
    },
  }
}
</script>

<style lang="scss" scoped>
.badge {
  background: #F9FAFB !important;
  color: #333333 !important;
  border-radius: 6px;
  display: inline-flex;
  position: relative;
  align-items: center;
  vertical-align: middle;
  padding: 0 6px;
  height: 24px;
  border: 1px solid #EEEEEE;
}
</style>